"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var manager_master_1 = require("./manager-master");
exports.ManagerMaster = manager_master_1.MasterBsiManager;
var manager_slave_1 = require("./manager-slave");
exports.ManagerSlave = manager_slave_1.SlaveBsiManager;
//# sourceMappingURL=index.js.map